import React from 'react';

const BuyerDashboard = () => {
  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <h1>Buyer Dashboard</h1>
      <p>This section is under development. Coming soon!</p>
    </div>
  );
};

export default BuyerDashboard;
